<section class="page-title-area">
  <div class="container">
    @for (pageTitle of pageTitleArea; track pageTitle) {
      <div class="page-title-content">
        <h1>{{pageTitle.title}}</h1>
        <ul>
          <li><a routerLink="/">Home</a></li>
          <li>{{pageTitle.title}}</li>
        </ul>
      </div>
    }
  </div>

  <div class="shape-img1"><img src="assets/img/shape/shape1.svg" alt="image"></div>
  <div class="shape-img2"><img src="assets/img/shape/shape2.png" alt="image"></div>
  <div class="shape-img3"><img src="assets/img/shape/shape3.png" alt="image"></div>
</section>

<section class="gallery-area pt-100 pb-70">
  <div class="container">
    <div class="row">
      @for (Image of galleryImages; track Image) {
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="single-gallery-item">
            <a data-fancybox="gallery" href="{{ Image.img }}">
              <img [src]="Image.img" alt="Devotory project gallery image">
            </a>
          </div>
        </div>
      }
    </div>
  </div>
</section>